import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { IndustryLResponse } from '@doda/api-client/aspida/@types';
import { appAxios } from '../../libs/axios/appAxios';

export const getIndustry = async (headers: IncomingHttpHeaders) => {
  return appAxios({
    url: '/api/v1/industry',
    headers,
  }).then((res: AxiosResponse<IndustryLResponse[]>) => {
    return res.data;
  });
};
